// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-module--logo--34wAw","active":"logo-module--active--1YXYs","hiBounce":"logo-module--hi-bounce--1sXpY","dark":"logo-module--dark---2Frw"};